import ReactTable from "common/components/ReactTable/ReactTable";
import SubTitle from "components/SubTitle";
import React from "react";
import { Spinner } from "react-bootstrap";
import { tableColumns } from "../types";
import Header from "./Header";
import { FilterFields } from "./types";

type Props = {
  title: string;
  titleFor: string;
  isLoading: boolean;
  // eslint-disable-next-line
  data: any;
  columns: tableColumns[];
  pageIndex: number;
  pageCount: number;
  setPageIndex: React.Dispatch<React.SetStateAction<number>>;
  submitFilter: (filters: FilterFields[]) => void;
  filterValues: FilterFields[];
};

const ExtraDataModal = ({
  title,
  titleFor,
  isLoading,
  data,
  columns,
  pageIndex,
  pageCount,
  setPageIndex,
  submitFilter,
  filterValues,
}: Props) => {
  const excelEndpoint = title.includes("רכב")
    ? `GetReportsByLicenseNumberAsExcelFile?licenseNumber=${titleFor}`
    : `GetReportsByControllerAsExcelFile?controllerId=${titleFor}`;
  return (
    <div>
      <SubTitle>{title}</SubTitle>
      {isLoading ? (
        <div className="loader-container">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <>
          <Header
            columns={columns.filter((col) => col.accessor !== "coordinates")}
            submitFilter={submitFilter}
            filterValues={filterValues}
            thereIsData={data?.length > 0}
            excelEndpoint={excelEndpoint}
          />
          <ReactTable
            data={data}
            columns={columns}
            pageIndex={pageIndex}
            setPageIndex={setPageIndex}
            pageCount={pageCount}
          />
        </>
      )}
    </div>
  );
};

export default ExtraDataModal;
